@use '../../styling/colors.scss' as *;

.SortIndicator {
  position: relative;
  font-size: 0; // prevent spaces in markup from affecting inline layout

  align-items: center;

  svg {
    fill: $theme-form-alert-info-icon;
  }
}